import React from 'react';
import { useBannerContext } from '../../context/BannerContext';
import { useLoginBannerMutation } from '../../hooks/useLoginBanner';
import Modal from '../Modal/NewModal';

export const LoginBannerModal = () => {
  const { showBanner, setShowBanner } = useBannerContext();
  const { downloadInformation, dismissBanner } = useLoginBannerMutation();
  const hideBanner = () => setShowBanner(false);

  return (
    <>
      {showBanner && (
        <Modal
          isOpen={showBanner}
          onClose={hideBanner}
          header="Welcome!"
          actions={[
            { title: 'Dismiss', kind: 'secondary', onClick: () => dismissBanner() },
            {
              title: 'Remind',
              kind: 'primary',
              autoClose: false,
              onClick: hideBanner
            }
          ]}
          size="medium"
          dataTestid="login-banner-modal"
        >
          <div className="py-4 px-6 font-effra space-y-5">
            <h2 className="font-effra text-1xl">
              The updated Client Portal is our first step to make it easier to manage your population and interact with
              Teladoc Health.
            </h2>
            <p className="font-effra text-gray-50">
              Be sure to update your bookmark to:
              <a
                className="ml-2 text-blue-500"
                href="https://clientportal.teladoc.com"
                target="_blank"
                rel="noreferrer"
              >
                https://clientportal.teladoc.com
              </a>
            </p>
            <p className="font-effra text-base">
              Resources to help you navigate the Client Portal :{' '}
              <button onClick={downloadInformation} data-testid="download-button" className="text-blue-500 h-auto">
                click here to download
              </button>{' '}
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};
